import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const textUiNodeSpec: UiNodeSpec<'text'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { value: '' }, id: getUID(), kind: 'text', disabled: false }),
    controls: getNodeCfg => ({ value: { cfg: { kind: 'text', placeholder: 'Enter a text value' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.value } }),
    inputs: () => ({}),
    kindLabel: 'Text',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
